export default __webpack_public_path__ + "static/media/T7-output.c1c1363e.png";